import { Chip, Button } from "@mui/material";
import { formatDate } from "../../../helpers/formatingFunctions";
import ConfirmActionButton from "../../../components/Fleet/ConfirmActionButton/ConfirmActionButton";
import axios from "axios";
import { apiVariable } from "../../../api/apiVariable";

export type MoneyRequestStatusType = "active" | "used" | "inactive";

export const statusColors: Record<
  MoneyRequestStatusType,
  {
    label: string;
    color:
      | "default"
      | "primary"
      | "secondary"
      | "error"
      | "info"
      | "success"
      | "warning";
  }
> = {
  used: { label: "Used", color: "success" },
  active: { label: "Active", color: "warning" },
  inactive: { label: "Inactive", color: "error" },
};

export const relayPaymentsTableColumns = (
  token: string | null | undefined,
  company: string
) => {
  const handleDownloadReceipt = async (chargeId: string) => {
    try {
      const response = await axios.get(
        `${apiVariable}/charges/${chargeId}/receipt`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { company: company },
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `receipt_${chargeId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading receipt:", error);
    }
  };

  return [
    { field: "code", headerName: "Code", width: 150 },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      renderCell: (params: any) => (
        <Chip
          label={statusColors[params.value as MoneyRequestStatusType].label}
          color={statusColors[params.value as MoneyRequestStatusType].color}
        />
      ),
    },
    {
      field: "constraint_amount",
      headerName: "Constraint Amount",
      width: 150,
      valueFormatter: (value: number) => value && `$${value / 100}`,
    },
    { field: "note", headerName: "Note", width: 150 },
    {
      field: "created_at",
      headerName: "Created At",
      width: 150,
      renderCell: (params: any) => formatDate(params.value),
    },
    {
      field: "delete",
      headerName: "",
      width: 130,
      renderCell: (params: any) =>
        params.row.status === "active" && (
          <ConfirmActionButton
            id={params.row.id}
            entityType="RelayCode"
            actionType="delete"
            entityLabel="relay code"
            queryKey="relayCodes"
            buttonLabel="Delete"
            buttonColor="error"
            queryParam={{ company: company }}
          />
        ),
    },
    {
      field: "downloadReceipt",
      headerName: "Receipt",
      width: 130,
      renderCell: (params: any) => {
        if (params.row.status === "used") {
          return (
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleDownloadReceipt(params.row.charge_ids[0])}
            >
              Download
            </Button>
          );
        }
        return null;
      },
    },
  ];
};
